import { Stack, Box, Button, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorImage from '../../assets/images/error_Illustration.png';

const ErrorElementPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Stack
      spacing={{ base: 'base', lg: '2xl' }}
      h="100vh"
      w="full"
      maxW={{ lg: '32rem' }}
      marginX="auto"
      paddingX={{ base: '2xl', lg: 0 }}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Box w="full" h={{ base: '13rem', lg: '15.625rem' }} overflow="hidden">
        <Image src={ErrorImage} alt="Error-image" loading="lazy" w="full" h="full" objectFit="contain" />
      </Box>
      <Stack>
        <Text fontSize={{ base: 'xl', lg: '2xl' }} fontWeight="bold">
          Something Broke
        </Text>
        <Text fontSize="base" color="black300">
          An unexpected error occurred. Please try refreshing the page or contact support if the problem doesn’t go
          away.
        </Text>
      </Stack>
      <Button
        onClick={() => navigate(-1)}
        variant="primary"
        fontSize="md"
        rounded="md"
        paddingY="3xl"
        paddingX={{ base: '7xl', lg: '8xl' }}
      >
        Go Back
      </Button>
    </Stack>
  );
};

export default ErrorElementPage;
